"use client";

import StoreDetails from "@/containers/StoreDetails";
import { envs } from "@/utils/constants";

import useFetch from "@/hooks/useFetch";
import { getShopById, getShopBySlug } from "@/requests/page";
import { getS3ImageUrl } from "@/utils/routes";
import { Wrapper } from "@googlemaps/react-wrapper";
import { useRouter } from "@/hooks/useCompatRouter";

// store location page
const StoreDetailsPage = () => {
  const router = useRouter();
  const { slug } = router.query;

  // const store = storeLocations[Number(slug?.toString())];

  const storeRes = useFetch(() => getShopBySlug(slug?.toString() || ""), {
    deps: [slug?.toString()],
  });

  const store = storeRes.response
    ? {
        ...storeRes.response,
        media: storeRes.response.media.map((m: any) =>
          getS3ImageUrl(typeof m === "string" ? m : m.path)
        ),
      }
    : null;

  if (!store) return null;

  return (
    <Wrapper apiKey={envs.mapApiKey} region="BD">
      {store && <StoreDetails key={slug?.toString()} store={store} />}
    </Wrapper>
  );
};

export default StoreDetailsPage;
